import * as React from "react"

const IconBack = (props) => {
  return (
  <svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#4F4FFF" strokeWidth={2} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.849 11.151a1.2 1.2 0 0 0-1.698 0l-4 4a1.2 1.2 0 0 0 0 1.697l4 4a1.2 1.2 0 1 0 1.698-1.697L15.697 16l3.152-3.152a1.2 1.2 0 0 0 0-1.697Z"
      fill="#4F4FFF"
    />
  </svg>
)}

export default IconBack
